import React from 'react';

class SampleViewRound extends React.Component {

    wellSelected(row, col) {
        this.props.handleSelectRowSample(row, col, this.props.plate.name);
        this.props.handleSelectRowBuffer(row, col, this.props.plate.name);
    }

    wellClick() {
    }

    render() {
        if (this.props.bufferTableRows) {
            let found1 = this.props.bufferTableRows.find(bufferTableRow => {
                return bufferTableRow.plate === this.props.plate.name && bufferTableRow.row === this.props.platerow && bufferTableRow.column === this.props.platecol
            });

            if (found1) {
                return <circle
                    style={{
                        stroke: this.props.selectedWell === `${this.props.plate.name}:${this.props.platerow}:${this.props.platecol}` ? 'red' : 'rgb(136, 136, 136)'
                    }}
                    cx="50%"
                    cy="50%"
                    r={this.props.radius}
                    strokeWidth="1"
                    fill="#0097a7"
                    onClick={() => {
                        this.wellSelected(this.props.platerow, this.props.platecol);
                        this.wellClick(`${this.props.platerow}${this.props.platecol}`);
                        this.props.handleShowBufferTable();
                    }}
                />
            }
        }

        if (this.props.sampleTableRows) {
            let found2 = this.props.sampleTableRows.find(sampleTableRow => {
                return sampleTableRow.plate === this.props.plate.name && sampleTableRow.row === this.props.platerow && sampleTableRow.column === this.props.platecol
            });

            if (found2) {
                return <circle
                    style={{
                        stroke: this.props.selectedWell === `${this.props.plate.name}:${this.props.platerow}:${this.props.platecol}` ? 'red' : 'rgb(136, 136, 136)'
                    }}
                    cx="50%"
                    cy="50%"
                    r={this.props.radius}
                    stroke="rgb(136, 136, 136)"
                    strokeWidth="1"
                    fill="rgb(34, 167, 78)"
                    onClick={() => {
                        this.wellSelected(this.props.platerow, this.props.platecol);
                        this.wellClick(`${this.props.platerow}${this.props.platecol}`);
                        this.props.handleShowSampleTable();
                    }}
                />
            }
        }
        return null;
    }
}
export default SampleViewRound;


// WEBPACK FOOTER //
// ./src/components/saxs/CrystalPlate/SampleViewRound.jsx